module.exports = __webpack_public_path__ + "static/media/blog-bg.b4880a36.png";